export const auditConstant = {
    GET_PATIENTS_SUCCESS: 'AUDIT_GET_PATIENTS_SUCCESS',
    GET_ACCESSED_BY_SUCCESS: 'AUDIT_GET_ACCESSED_BY_SUCCESS',
    GET_SUCCESS: 'AUDIT_GET_SUCCESS',
    CREATED: 'AUDIT_CREATED',
    CHANGE: 'AUDIT_CHANGE'
};
